/**
 * Parses "DD/MM/YYYY HH:MMAM" and returns "Today", "Yesterday", or "Mon DD, YYYY".
 */
export function getDateLabel(timestamp: string): string {
  const datePart = timestamp.split(" ")[0];
  const [day, month, year] = datePart.split("/").map(Number);
  const messageDate = new Date(year, month - 1, day);
  messageDate.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (messageDate.getTime() === today.getTime()) return "Today";
  if (messageDate.getTime() === yesterday.getTime()) return "Yesterday";

  return messageDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/**
 * Extracts only the time portion from "DD/MM/YYYY HH:MMAM".
 * e.g. "23/07/2026 9:30AM" → "9:30AM"
 */
export function getTimeOnly(timestamp: string): string {
  const parts = timestamp.split(" ");
  return parts.length >= 2 ? parts[1] : timestamp;
}
